export default {
  namespaced: true,
  state: {
    // 临时患者信息
    patient: {
      age: '',
      ageUnit: '',
      sex: '',
      physiologicalState: '',
      chiefComplaints: []
    }
  },
  getters: {},
  mutations: {
    // 设置患者信息
    setPatient(state: any, payload: any) {
      state.patient = Object.assign(state.patient, payload)
    },
    // 清楚患者信心
    clearPatient(state: any) {
      state.patient = {
        age: '',
        ageUnit: '',
        sex: '',
        chiefComplaints: []
      }
    }
  },
  actions: {}
}
